import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="More testimonials" className="bg-warm" data-id="element-137" data-mp="20fowudtw93h2">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "17px",
      paddingBottom: "11px"
    }} data-id="element-138" data-mp="25a2vcp3urqpy">
        <h2 className="text-center font-display text-3xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-139" data-mp="2a731t14m6vhl">
          Athletes who are already using the system
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-140" data-mp="1hjpe7tmt3ca5">
          {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.05} data-id="element-141" data-mp="1mgyykuvc8xr4" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}